import React, {useContext} from "react";
import {
  AiBrain01Icon, CodeIcon, Database02Icon, EyeIcon, Tag01Icon, Target02Icon, WorkflowIcon
} from "@hugeicons/core-free-icons";

// How the side menu is drawn. "rail": the legacy flow editor. "panel": registry projects - a white list panel like
// the supervision list, with one search over every section. search: that shared search ("panel" only).
export const SideMenuStyleContext = React.createContext({variant: "rail", search: ""});

export const useSideMenuStyle = () => useContext(SideMenuStyleContext);

// The section a row belongs to, so panel rows can show the section's icon and colour
export const SideSectionContext = React.createContext(null);

// Icon and colour of each section, by ListBlock title
export const SECTION_STYLES = {
  Flows: {icon: WorkflowIcon, color: "#8491F7"},
  Intents: {icon: Target02Icon, color: "#3D86C6"},
  Entities: {icon: Database02Icon, color: "#2F9A6A"},
  Skills: {icon: AiBrain01Icon, color: "#8A6FE0"},
  Watchdogs: {icon: EyeIcon, color: "#D9A13A"},
  Constants: {icon: CodeIcon, color: "#6B6B80"},
  Tags: {icon: Tag01Icon, color: "#C2455A"},
};
